import { render, staticRenderFns } from "./UserCons.vue?vue&type=template&id=3319ff83&"
import script from "./UserCons.vue?vue&type=script&lang=js&"
export * from "./UserCons.vue?vue&type=script&lang=js&"
import style0 from "./UserCons.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports